


















import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency.js";
import { HsabExpenseResponse } from "@/shared/types";
import HsabExpenseCardRowPaymentDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPaymentDetail.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: { HsabExpenseCardRowPaymentDetail }
})
export default class AccountHolderExpenseReimbursement extends Vue {
  formatCurrency = formatCurrency;
  hsabExpenseFormStore = useHsabExpenseFormStore();

  @Prop()
  expense: HsabExpenseResponse;

  get hasReimbursement () {
    return this.expense && this.expense.reimbursement;
  }

  get hasOverflowReimbursements () {
    return this.hasReimbursement
        && this.expense.reimbursement.overflowReimbursements
        && this.expense.reimbursement.overflowReimbursements.length > 0;
  }
}
